import script from "./OnboardingAiGoalsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiGoalsStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiGoalsStep.vue?vue&type=style&index=0&id=008bfa0e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008bfa0e"]])

export default __exports__